<template>
  <div class="mt-6">
    <v-row align="center" class="my-2 container" v-if="!isEditMode">
      <span class="text-subtitle-1 mr-2">{{ $t('lds.overallCap')}}:</span>
      <div v-if="liquidatedDamagesCapPercent">
        <span class="text-subtitle-1 font-weight-medium">{{ liquidatedDamagesCapPercent * 100 }}% </span>
        <span class="text-subtitle-1 font-weight-light mr-2">{{ $t('lds.overallCapPercent')}}</span>
      </div>
        <PricesDisplay
          :prices="overallCapValueCents"
          :contractCurrencies="contract.currencies"
          :chosenCurrency="contract.chosenCurrency"
          :itemCurrency="selectedCurrency"
        />
      <v-btn
        icon
        small
        v-if="canUserEdit"
        @click="toggleEditMode"
        class="ml-4"
      >
        <v-icon>mdi-pencil </v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="6">
      <LiquidatedDamagesCapForm
        class="mt-6 container gap-md"
        v-if="isEditMode"
        :contractCurrencies="contract.currencies"
        :parts="contract.parts"
        :errorsCents="errorMessages('valueCents')"
        :valueCents="form.valueCents"
        :valuePercent="form.valuePercent"
        :currency="form.currency"
        :isPercentMode="isPercentMode"
        @TOGGLE_PERCENT_MODE="togglePercentMode"
        @CENTS_INPUT="handleCentsInput"
        @PERCENT_INPUT="handlePercentInput"
        @CURRENCY_INPUT="handleCurrencyInput"
      >
        <v-col class="mt-4">
          <v-btn
            x-small
            rounded
            dark
            color="primary"
            @click="handleSave"
          >
            {{ $t('common.save') }}
          </v-btn>
          <v-btn
            x-small
            rounded
            class="ml-2"
            @click="toggleEditMode"
            >
            {{ $t('common.cancel') }}
          </v-btn>
        </v-col>
      </LiquidatedDamagesCapForm>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </div>

</template>

<script>
import { updateContract } from '../../services'
import { errorMessageGenerator, liquidatedDamageCapModel } from '../../validators'

export default {
  name: 'LiquidatedDamagesCap',
  props: {
    contract: Object,
    canUserEdit: Boolean,
    capFromAdjustedContractPrice: Object
  },
  data () {
    return {
      form: {
        valueCents: this.contract.liquidatedDamagesCap.valueCents || null,
        valuePercent: this.contract.liquidatedDamagesCap.valuePercent || null,
        currency: this.contract.liquidatedDamagesCap.currency || this.contract.currencies[0].key
      },
      isPercentMode: !!this.contract.liquidatedDamagesCap.valuePercent,
      isEditMode: false
    }
  },
  computed: {
    liquidatedDamagesCapPercent () {
      return this.contract.liquidatedDamagesCap.valuePercent
    },
    liquidatedDamagesCapCents () {
      return this.contract.liquidatedDamagesCap.valueCents
    },
    liquidatedDamagesCapCurrency () {
      return this.contract.liquidatedDamagesCap.currency
    },
    overallCapValueCents () {
      const percent = this.liquidatedDamagesCapPercent
      if (percent) {
        return this.capFromAdjustedContractPrice
      }
      return this.liquidatedDamagesCapCents
    },
    selectedCurrency () {
      return this.contract.currencies.find(i => i.key === this.contract.liquidatedDamagesCap.currency)
    }
  },
  methods: {
    handleCentsInput (value) {
      this.form.valueCents = value
    },
    handlePercentInput (value) {
      this.form.valuePercent = value
    },
    handleCurrencyInput (value) {
      this.form.currency = value
    },
    toggleEditMode () {
      this.isEditMode = !this.isEditMode
    },
    togglePercentMode () {
      this.isPercentMode = !this.isPercentMode
    },
    async handleSave () {
      await this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        await updateContract({
          ...this.contract,
          liquidatedDamagesCap: { ...this.form }
        })
        this.$eventBus.$emit('SET_LD_CAP', { ...this.form })
        this.toggleEditMode()
      }
    },
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    }
  },
  watch: {
    isPercentMode (v) {
      if (v) {
        this.form.valueCents = null
        this.form.valuePercent = this.liquidatedDamagesCapPercent || 0
        this.form.currency = this.contract.currencies[0].key
      } else {
        this.form.valueCents = this.liquidatedDamagesCapCents || 0
        this.form.valuePercent = null
        this.form.currency = this.liquidatedDamagesCapCurrency || this.contract.currencies[0].key
      }
    }
  },
  validations: liquidatedDamageCapModel
}
</script>
